/* eslint-disable import/prefer-default-export */
import * as yup from 'yup';

const WeOweRowSchema = yup.object().shape({
    nameOfItem: yup
        .string()
        .required('Name of item is required')
        .test(
            'not-empty',
            'Name of item is required',
            (value) => (value ?? '').trim().length >= 1,
        )
        .test(
            'max-length',
            'Name of item has a maximum limit of 100 characters',
            (value) => (value ?? '').trim().length <= 100,
        ),
});

const WeOweSchema = yup.array().of(
    WeOweRowSchema,
);

export {
    WeOweRowSchema,
    WeOweSchema,
};
